<script lang="ts" setup>
  import Icon from "@/components/Icon.vue";
  import { useAppStore } from "@/stores/app";
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";

  const appStore = useAppStore();
  const subscriptionFlowStore = useSubscriptionFlowStore();
</script>

<template>
  <div class="container">
    <div class="d-flex flex-column align-center text-center">
      <div class="title">
        {{ $t(`welcome.${appStore.labelVersion}.title`) }}
      </div>
    </div>
    <div class="content">
      <div class="list">
        <v-row class="pt-3">
          <v-col cols="2" class="align-content-end">
            <Icon
              icon="credit_card"
              :size="26"
              class="icon"
            />
          </v-col>
          <v-col cols="10">
            <span class="t-bold">{{ $t(`welcome.${appStore.labelVersion}.link-card.title`) }}</span> {{ $t(`welcome.${appStore.labelVersion}.link-card.text`) }}
          </v-col>
        </v-row>
        <v-row class="pt-3">
          <v-col cols="2" class="align-content-end">
            <Icon
              icon="redeem"
              :size="26"
              class="icon"
            />
          </v-col>
          <v-col cols="10">
            <span class="t-bold">{{ $t(`welcome.${appStore.labelVersion}.earn-rewards.title`) }}</span> {{ $t(`welcome.${appStore.labelVersion}.earn-rewards.text`) }}
          </v-col>
        </v-row>
        <v-row class="pt-3 pb-5">
          <v-col cols="2" class="align-content-end">
            <Icon
              icon="volunteer_activism"
              :size="26"
              class="icon"
            />
          </v-col>
          <v-col cols="10">
            <span class="t-bold">{{ $t(`welcome.${appStore.labelVersion}.make-a-difference.title`) }}</span>
            {{ $t(`welcome.${appStore.labelVersion}.make-a-difference.text`) }}
          </v-col>
        </v-row>
      </div>
      <div class="mt-12">
        <v-btn
          class="mt-2"
          type="submit"
          color="primary"
          width="320"
          rounded="lg"
          @click="subscriptionFlowStore.advanceStep"
        >
          {{ $t('common.next') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

  .container {
    display: flex;
    font-size: 16px;
    flex-direction: column;
    align-items: center;
    max-width: 500px;
    margin: 0 auto;

    .title {
      line-height: 130%;
      font-size: getFontSize('large-2');
      font-weight: getFontWeight('bold');
      margin-bottom: 75px;
    }

    .content {
      width: 100%;
      display: flex;
      font-size: 16px;
      flex-direction: column;
      align-items: center;

      .list {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: justify;

        .icon {
          position: relative;
          //left: 5px;
          border-radius: 50%;
          padding: 10px;
          color: rgb(var(--v-theme-on-background));
          border: 1px solid rgba(var(--v-theme-on-background), 0.35);
          text-align: center;
        }
      }

    }
  }

  @media(max-width: breakpoint(md) - 1px) {
    .title {
      font-size: getFontSize('subtitle-1');
    }
  }

</style>
